import { useFlagStore } from 'stores/flagStore'
import { acceptFlag, createFlag, deleteFlag, markFixedFlag, markUnfixedFlag, rejectFlag, undeleteFlag, updateFlag } from '../api'

export function useFlagActions(packageId) {
  const addFlag = useFlagStore((s) => s.addFlag)
  const updateFlagInStore = useFlagStore((s) => s.updateFlag)
  const removeFlagFromStore = useFlagStore((s) => s.removeFlag)

  const create = async (flaggableType, flaggableId, reason) => {
    const { data } = await createFlag(packageId, { flaggableType, flaggableId, reason })
    addFlag(data.flag)
    return data.flag
  }

  const update = async (flagId, reason) => {
    const { data } = await updateFlag(packageId, flagId, { reason })
    updateFlagInStore(flagId, data.flag)
    return data.flag
  }

  const remove = async (flagId) => {
    await deleteFlag(packageId, flagId)
    removeFlagFromStore(flagId)
  }

  const unRemove = async (flagId) => {
    const { data } = await undeleteFlag(packageId, flagId)
    addFlag(data.flag)
    return data.flag
  }

  const markFixed = async (flagId) => {
    const { data } = await markFixedFlag(packageId, flagId)
    updateFlagInStore(flagId, data.flag)
    return data.flag
  }

  const markUnfixed = async (flagId) => {
    const { data } = await markUnfixedFlag(packageId, flagId)
    updateFlagInStore(flagId, data.flag)
    return data.flag
  }

  const accept = async (flagId) => {
    const { data } = await acceptFlag(packageId, flagId)
    updateFlagInStore(flagId, data.flag)
    return data.flag
  }

  const reject = async (flagId) => {
    const { data } = await rejectFlag(packageId, flagId)
    updateFlagInStore(flagId, data.flag)
    return data.flag
  }

  return { create, update, remove, unRemove, markFixed, markUnfixed, accept, reject }
}
